import { Card, Descriptions, Row, Tag } from "antd";
import React, { useMemo } from "react";
import dayjs from "dayjs";
import { ArchivedCaseSummaryFinanceDetailsAdhocTransaction } from "../../../generated";
import { DATE_FORMAT, FormatDate } from "../../../constants";

export interface TransactionsLiteProps {
  data: TransactionData;
}

export interface TransactionData {
  totalReceived: number;
  totalSent: number;
  transactionsData: ArchivedCaseSummaryFinanceDetailsAdhocTransaction[];
}

export const TransactionsLite: React.FC<TransactionsLiteProps> = (props) => {
  const labelStyle = {
    justifyContent: "center",
  };
  const memoizedTransactions = useMemo(() => {
    if (props.data.transactionsData.length === 1 && !props.data.transactionsData[0].amount) {
      return <p className="px-5">No transactions have been made for this application.</p>;
    } else {
      return props.data.transactionsData.map((transaction) =>
        transaction?.amount ? (
          <React.Fragment key={transaction.transactionReference?.referenceId}>
            <Card
              bordered={true}
              style={{
                width: "100%",
                height: "30%",
                marginTop: 20,
              }}
            >
              <Descriptions
                title={undefined}
                layout="vertical"
                size="small"
                column={2}
                className="w-[800px]"
              >
                <Descriptions.Item label="Date">
                  {FormatDate(transaction.transactionReference?.completedAt, 
                    "DD-MMM-YY"
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Description" labelStyle={labelStyle}>
                  {transaction.amount && transaction.amount < 0
                    ? `${transaction.reason} Refund US$${Math.abs(
                        transaction.amount
                      )}`
                    : `${transaction.reason} US$${transaction.amount}`}
                </Descriptions.Item>
                <Descriptions.Item label="ID" labelStyle={labelStyle}>
                {transaction.transactionReference?.referenceId}
                </Descriptions.Item>
                <Descriptions.Item label="Activity">
                <Tag>
                    {`Sent ${dayjs(transaction.transactionReference?.completedAt)
                      .format(DATE_FORMAT)
                      .toUpperCase()}`}
                  </Tag>
                </Descriptions.Item>
              </Descriptions>
            </Card>
          </React.Fragment>
        ) : null
      );
    }
    }, [props.data.transactionsData]);

  return (
    <div>
      {/* Total Received and Sent Section */}
      <Row gutter={[5, 5]}>
        <Descriptions
          title={undefined}
          layout="vertical"
          size="small"
          column={2}
          className="w-[800px]"
          style={{ marginTop: 20 }}
        >
          <Descriptions.Item label="Total Received">
            US${props.data.totalReceived}
          </Descriptions.Item>
          <Descriptions.Item label="Total Sent">
            US${props.data.totalSent}
          </Descriptions.Item>
        </Descriptions>
      </Row>

      {/* Transactions Section */}
      <h4 style={{ marginTop: 10 }}>Transactions</h4>
      <div>{memoizedTransactions}</div>
    </div>
  );
};
